import { SuggestionQuestion } from "./SuggestionQuestion";

import { useMedicationFieldSuggestions } from "@/hooks/useMedicationFieldSuggestions";

const NOT_APPLICABLE = "No single strength applies";

/** Only mounted when strength needs a nurse's answer; never preselects an LLM guess. */
export function StrengthQuestion({
    visitId,
    productName,
    value,
    onChange,
    notApplicable,
    onNotApplicableChange,
    showError = false
}: {
    visitId: string | undefined;
    productName: string;
    value: string;
    onChange: (value: string) => void;
    notApplicable: boolean;
    onNotApplicableChange: (value: boolean) => void;
    showError?: boolean;
}) {
    const { suggestions, loading } = useMedicationFieldSuggestions(visitId, productName, [
        "strengths"
    ]);
    return (
        <SuggestionQuestion
            label="Product strength"
            required
            value={notApplicable ? NOT_APPLICABLE : value}
            onChange={(choice) => {
                onNotApplicableChange(choice === NOT_APPLICABLE);
                onChange(choice === NOT_APPLICABLE ? "" : choice);
            }}
            options={[...(suggestions?.strengths ?? []), NOT_APPLICABLE]}
            loading={loading}
            showError={showError}
            hint="Select the strength on the label, separately from the amount taken."
            placeholder="For example, 5 mg or 100 units/mL"
            errorMessage="Select the label strength or confirm that no single strength applies."
        />
    );
}
